export const statusPanel = {
  statusPanels: [
    {
      statusPanel: 'agTotalAndFilteredRowCountComponent',
      key: 'totalAndFilter',
      align: 'left'
    },
    { statusPanel: 'agSelectedRowCountComponent', align: 'left' },
    { statusPanel: 'agAggregationComponent', align: 'right' }
  ]
}

export const sideBar = {
  toolPanels: [
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'columns',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        syncLayoutWithGrid: true
      }
    },
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
      toolPanelParams: {
        syncLayoutWithGrid: true
      }
    }
  ],
  position: 'right',
  defaultToolPanel: 'columns'
}

export const aggFuncs = {
  // 'zero': function () {
  //   return 0;
  // }
}

const chartPanelTemplate =
  '<div class="chart-wrapper ag-theme-alpine">' +
  '<div class="chart-wrapper-top">' +
  '<span class="chart-wrapper-title"></span>' +
  '<button class="chart-wrapper-close">Destroy Chart</button>' +
  '</div>' +
  '<div class="chart-wrapper-body"></div>' +
  '</div>'

export const createChartContainer = (containerClass) => {
  return (chartRef) => {
    var eChart = chartRef.chartElement

    var eTemp = document.createElement('div')
    eTemp.innerHTML = chartPanelTemplate
    var eChartWrapper = eTemp.firstChild
    console.log(containerClass)
    var eParent = document.querySelector(`.${containerClass}`)

    eParent.appendChild(eChartWrapper)

    eChartWrapper.querySelector('.chart-wrapper-body').appendChild(eChart)
    eChartWrapper.querySelector('.chart-wrapper-title').innerText =
      'Chart Created At ' + new Date()

    eChartWrapper
      .querySelector('.chart-wrapper-close')
      .addEventListener('click', function () {
        chartRef.destroyChart()
        eParent.removeChild(eChartWrapper)
      })
  }
}
